const space = {
  formSection: '2rem',
  form: '3rem',
  formTitle: '1.5rem',
  formSubmit: '4.625rem'
};

export default space;
